import { map } from "rxjs";
import { apiService } from "../../ApiService";
import { User } from "../../../model/User/User";

export type PasswordFormData = {
  oldPassword: string;
  newPassword: string;
  passwordConfirm: string;
};

export const updatePassword = (params: PasswordFormData) => {
  return apiService
    .put<{ user: User }>({
      path: `v1/me/password`,
      body: params,
      requiresAuthPolicy: "user",
    })
    .pipe(map((res) => res.user));
};
